import { createContext, useContext } from "react";

interface ILayerContext {
  root?: HTMLElement;
  zIndex?: number;
}

const LayerContext = createContext<ILayerContext>({});

export const LayerContextProvider = LayerContext.Provider;
export const LayerContextConsumer = LayerContext.Consumer;

export const useLayerContext = (): ILayerContext => useContext(LayerContext);

export default LayerContext;
